import { render } from "./MainSpiner.vue?vue&type=template&id=222f5b4c&scoped=true"
import script from "./MainSpiner.vue?vue&type=script&lang=js"
export * from "./MainSpiner.vue?vue&type=script&lang=js"

import "./MainSpiner.vue?vue&type=style&index=0&id=222f5b4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f5b4c"]])

export default __exports__